
// helper do bezpiecznego wysyłania statystyk
function safeSendStats() {
  if (typeof window !== "undefined" && typeof window.sendStats === "function") {
    // eslint-disable-next-line prefer-rest-params
    window.sendStats.apply(window, arguments);
  }
}

// statystyki ćwiartek (25/50/75 tylko raz)
const handleQuartiles = (() => {
  // Map: mid -> Set(thresholds wysłanych)
  const sent = new Map();
  const thresholds = [25, 50, 75];

  return (position, clipMid, clipName) => {
    if (clipMid == null || position == null) return;

    const p = Math.round(position * 100);
    // sprawdzamy, czy p jest w przedziałach [25,50), [50,75), [75,100)
    for (const t of thresholds) {
      if (p >= t && p < t + 25) {
        let s = sent.get(clipMid);
        if (!s) { s = new Set(); sent.set(clipMid, s); }
        if (!s.has(t)) {
          s.add(t);
          safeSendStats("video", `quarter=${t}`, clipName);
        }
        break;
      }
    }
  };
})();

// -- inicjalizacja playerów --------------------------------------------

document.querySelectorAll(".player").forEach((el, i) => {
  // nadaj id jeśli brak
  if (!el.id) el.id = `player_${i}`;

  const url = el.dataset.url;
  if (!url) return; // brak URLa = pomijamy

  WP.push(() => {
    let playerInitialized = false;
    let clipName = "";
    let clipMid = "";

    const player = new WP.player({
      url,
      target: el.id,
      adv: false,
      hiderelated: true,
      extendedrelated: false,
      floatingplayer: false,
      autoplay: false,
      forceliteembed: false,
    });

    // na init -> ustaw głośność
    player.on("INIT", function () {
      if (!playerInitialized) {
        playerInitialized = true;
        if (typeof this.setVolume === "function") {
          this.setVolume(0.5);
        }
      }
    });

    // start filmu 
    player.on("START_MOVIE", function () {
      const data = (typeof player.getClipData === "function" ? player.getClipData() : {}) || {};
      clipName = data.title;
      clipMid  = data.mid;
      safeSendStats("video", "view", clipName);
    });

    // koniec filmu
    player.on("END_MOVIE", function () {
      safeSendStats("video", "end", clipName);
    });

    // ćwiartki
    player.on("UPDATE_POSITION", function () {
      const position = typeof player.getPosition === "function" ? player.getPosition() : undefined;
      handleQuartiles(position, clipMid, clipName);
    });
  });
});
